'use strict';

function Buttons() {

    var dataTableButtons = [
        {
            buttonClass: 'buttons-copy',
            buttonIcon: '<i class="fa fa-files-o"></i> '
        },
        {
            buttonClass: 'buttons-excel',
            buttonIcon: '<i class="fa fa-file-excel-o"></i> '
        },
        {
            buttonClass: 'buttons-print',
            buttonIcon: '<i class="fa fa-print"></i> '
        },
        {
            buttonClass: 'buttons-collection',
            buttonIcon: '<i class="fa fa-caret-down"></i> '
        }
    ];

    /********************************/
    // init buttons
    /********************************/
    this.initButtons = function () {
        $.each(dataTableButtons, function (key, button) {
            $('.' + button.buttonClass).prepend(button.buttonIcon);
        });

        this.updateButtonClasses();
    };

    /********************************/
    // update button classes
    /********************************/
    this.updateButtonClasses = function () {
        if ($('#singleStudent').length > 0) {
            $('#singleStudent').find('input[type="submit"]').removeClass('sv-btn-primary').addClass('sv-btn-default');
        }

        if ($('#allStudents').length > 0) {
            $('#allStudents').find('input[type="submit"]').removeClass('sv-btn-primary').addClass('sv-btn-block sv-btn-default');
        }

        $('.dt-button').removeClass('dt-button').addClass('sv-btn sv-btn-primary');

        $('#studentViewOptions').find('input[type="submit"]').each(function () {
            $(this).removeClass('sv-btn-block').addClass('sv-btn-block');
            if ($(this).parent().hasClass('active')) {
                $(this).removeClass('sv-btn-primary').addClass('sv-btn-success');
            }
            else {
                $(this).removeClass('sv-btn-primary').addClass('sv-btn-secondary');
            }
        });

        $('.formsubfree').each(function(){
            if($(this).attr('type') === 'submit'){
                $(this).removeClass('btn btn-primary sv-btn sv-btn-primary').addClass('sv-btn sv-btn-primary');
            }
        });
    };
}